import React from "react";
import MainWhiteContainer from "components/Buttons/MainWhiteContainer";
import DynamicField from "features/FolderManager/components/Questions/components/DynamicField";
import DynamicFreeInputField from "features/FolderManager/components/Questions/components/DynamicFreeInputField";

const styles = {
	fieldRow: {
		width: "100%",
		borderBottom: 10,
		paddingLeft: 10,
		marginBottom: 5,
	},
	crossRequired: {
		color: "#c5190e",
		fontSize: "0.6em",
		position: "absolute",
		bottom: "-25px",
		right: 0,
	},
	textCrossRequired: {
		position: "relative",
	},
};

const QuestionsBloc = ({ questions, setFieldValue, setFieldTouched, values, errors, touched, style, prevalidFolders, disabled }) => {
	return (
		<MainWhiteContainer title={questions.groupName}>
			{questions.questions.map((q, i) => {
				return (
					<div style={styles.fieldRow} key={"field_q_" + q.question.code}>
						<DynamicField
							field={q}
							setFieldValue={setFieldValue}
							setFieldTouched={setFieldTouched}
							values={values}
							errors={errors}
							touched={touched}
							prevalidFolders={prevalidFolders}
							disabled={disabled}
						/>
						<div style={{ height: 5 }}></div>

						{values[q.question.id] !== undefined && (values[q.question.id] === "freeInput" || values[q.question.id].includes("freeInput")) && (
							<DynamicFreeInputField
								name={q.question.id + "freeInput"}
								method={q.question.adding_free_input}
								setFieldValue={setFieldValue}
								setFieldTouched={setFieldTouched}
								values={values}
								errors={errors}
								touched={touched}
								prevalidFolders={prevalidFolders}
								disabled={disabled}
							/>
						)}
					</div>
				);
			})}
			{questions.questions.some((q) => q.required) && (
				<div style={styles.crossRequired}>
					* <span style={styles.textCrossRequired}>Champ requis</span>
				</div>
			)}
		</MainWhiteContainer>
	);
};

export default QuestionsBloc;
